import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getActiveSpace } from 'spaces/index';
import { closeModal } from 'modal/store/actions';
import Title3 from 'base/components/Title3';
import MainTitle from 'base/components/MainTitle';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import Button from 'base/components/Button';
import Col from 'base/components/Col';
import Row from 'base/components/Row';
import ModalHeader from 'modal/components/ModalHeader';
import { getActiveDocument } from '../../store/documents/selectors';
import { getEditingFolder, getActivePathStringWithSpace } from '../../store/folders/selectors';
import { getEntities } from '../../../store/entities/selectors';
import { deleteDocument } from '../../store/documents/actions';

const DeleteDocumentModal = ({
  name, closeModal, deleteDocument, activePathString, activeDocument,
}) => (
  <>
    <ModalHeader>
      <MainTitle>Delete Document</MainTitle>
    </ModalHeader>

    <FieldWrapper>
        Do you really want to delete
      <div>{activePathString}</div>
      <Title3>{activeDocument.name}</Title3>
    </FieldWrapper>

    <FieldWrapper>
      Do you really want to delete this document?
    </FieldWrapper>

    <Row>
      <Col>
        <Button isFullWidth variant="secondary" onClick={() => closeModal(name)}>No, cancel</Button>
      </Col>
      <Col>
        <Button
          isFullWidth
          variant="primary"
          onClick={() => { closeModal(name); deleteDocument(activeDocument); }}
        >
            Yes, delete
        </Button>
      </Col>
    </Row>
  </>
);
DeleteDocumentModal.propTypes = {
  name: PropTypes.string.isRequired,
  space: PropTypes.object.isRequired, // eslint-disable-line
  folder: PropTypes.object.isRequired, // eslint-disable-line
  closeModal: PropTypes.func.isRequired,
  deleteDocument: PropTypes.func.isRequired,
  activePathString: PropTypes.string.isRequired,
  activeDocument: PropTypes.objectOf(PropTypes.any).isRequired,
};

const mapStateToProps = (state) => ({
  space: getActiveSpace(state),
  folder: getEditingFolder(state),
  activePathString: getActivePathStringWithSpace(state),
  entities: getEntities(state),
  activeDocument: getActiveDocument(state),
});

const mapDispatchToProps = {
  deleteDocument,
  closeModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeleteDocumentModal);
